import React from 'react'
import { EloBaseIcon, EloBaseIconProps } from '../_base'

export const EloRadiobuttonUnselectedIcon: React.FC<EloBaseIconProps> = (props) => (
  <EloBaseIcon {...props}>
    <circle cx='10' cy='10' r='9.375' stroke='currentColor' strokeWidth='1.25' />
  </EloBaseIcon>
)
